
import { Injectable } from '@angular/core';
// FIX: Corrected import path for models.
import { LoyaltyReward, LoyaltyTier } from '../models/index';
import { getSupabase, isSupabaseConfigured } from '../firebase';
import { SupabaseClient } from '@supabase/supabase-js';

const REWARD_TABLE = 'loyalty_rewards';
const TIER_TABLE = 'loyalty_tiers';

@Injectable({ providedIn: 'root' })
export class LoyaltyService {
  private supabase: SupabaseClient | null = getSupabase();

  private toRewardDB(reward: Partial<LoyaltyReward>): any {
      return {
          id: reward.id,
          name: reward.name,
          description: reward.description,
          points_required: reward.points_required,
          cost: reward.cost,
          sku: reward.sku,
          imageUrl: reward.imageUrl,
          tag: reward.tag,
          monthly_limit: reward.monthly_limit,
          active: reward.active,
      };
  }

  private toTierDB(tier: Partial<LoyaltyTier>): any {
      return {
          id: tier.id,
          name: tier.name,
          min_points: tier.min_points,
          icon: tier.icon,
          benefits: tier.benefits,
      };
  }

  async getRewards(): Promise<LoyaltyReward[]> {
      if (!isSupabaseConfigured() || !this.supabase) { return []; }
      const { data, error } = await this.supabase.from(REWARD_TABLE).select('*');
      if (error) throw error;
      return data as LoyaltyReward[];
  }

  async addReward(rewardData: Omit<LoyaltyReward, 'id' | 'createdAt'>): Promise<LoyaltyReward> {
      if (!isSupabaseConfigured() || !this.supabase) { throw new Error("Database not connected"); }
      const { data, error } = await this.supabase.from(REWARD_TABLE).insert(this.toRewardDB(rewardData)).select().single();
      if (error) throw error;
      return data as LoyaltyReward;
  }
  
  async updateReward(rewardData: LoyaltyReward): Promise<LoyaltyReward> {
      if (!isSupabaseConfigured() || !this.supabase) { throw new Error("Database not connected"); }
      const { id, ...updateData } = rewardData;
      const { data, error } = await this.supabase.from(REWARD_TABLE).update(this.toRewardDB(updateData)).eq('id', id).select().single();
      if (error) throw error;
      return data as LoyaltyReward;
  }

  async deleteReward(id: string): Promise<void> {
      if (!isSupabaseConfigured() || !this.supabase) { throw new Error("Database not connected"); }
      const { error } = await this.supabase.from(REWARD_TABLE).delete().eq('id', id);
      if (error) throw error;
  }

  async getLoyaltyTiers(): Promise<LoyaltyTier[]> {
      if (!isSupabaseConfigured() || !this.supabase) { return []; }
      const { data, error } = await this.supabase.from(TIER_TABLE).select('*');
      if (error) throw error;
      return data as LoyaltyTier[];
  }
  
  async addLoyaltyTier(tierData: Omit<LoyaltyTier, 'id' | 'createdAt'>): Promise<LoyaltyTier> {
      if (!isSupabaseConfigured() || !this.supabase) { throw new Error("Database not connected"); }
      const { data, error } = await this.supabase.from(TIER_TABLE).insert(this.toTierDB(tierData)).select().single();
      if (error) throw error;
      return data as LoyaltyTier;
  }

  async updateLoyaltyTier(tierData: LoyaltyTier): Promise<LoyaltyTier> {
      if (!isSupabaseConfigured() || !this.supabase) { throw new Error("Database not connected"); }
      const { id, ...updateData } = tierData;
      const { data, error } = await this.supabase.from(TIER_TABLE).update(this.toTierDB(updateData)).eq('id', id).select().single();
      if (error) throw error;
      return data as LoyaltyTier;
  }

  async deleteLoyaltyTier(id: number): Promise<void> {
      if (!isSupabaseConfigured() || !this.supabase) { throw new Error("Database not connected"); }
      const { error } = await this.supabase.from(TIER_TABLE).delete().eq('id', id);
      if (error) throw error;
  }
}
